/**
 * ТЗ 0119 — цветовые токены ERP для нового кода. Значения — CSS-переменные
 * из `src/styles/theme.css`, поэтому один и тот же styled-компонент верно
 * выглядит и в светлой, и в тёмной теме без пересчёта стилей.
 *
 *   import { T } from 'services/ThemeTokens';
 *   const Card = styled.div`background: ${T.surface}; color: ${T.text};`;
 *
 * Сырой hex в новом коде — находка ревью: его тёмного варианта нет.
 * Для полупрозрачного цвета — `withAlpha(T.accent, 0.12)`.
 */
export const T = {
  bgApp: 'var(--c-bg-app)',
  surface: 'var(--c-surface)',
  surfaceSubtle: 'var(--c-surface-subtle)',
  surfaceRaised: 'var(--c-surface-raised)',
  surfaceSunken: 'var(--c-surface-sunken)',
  fill: 'var(--c-fill)',
  fillStrong: 'var(--c-fill-strong)',
  hover: 'var(--c-hover)',
  selected: 'var(--c-selected)',
  tooltip: 'var(--c-tooltip)',

  text: 'var(--c-text)',
  text2: 'var(--c-text-2)',
  textMuted: 'var(--c-text-muted)',
  textPlaceholder: 'var(--c-text-placeholder)',
  textFaint: 'var(--c-text-faint)',
  onAccent: 'var(--c-on-accent)',

  border: 'var(--c-border)',
  borderStrong: 'var(--c-border-strong)',

  accent: 'var(--c-accent)',
  accentHover: 'var(--c-accent-hover)',
  accentText: 'var(--c-accent-text)',
  accentTextHover: 'var(--c-accent-text-hover)',
  accentSoft: 'var(--c-accent-soft)',
  accentLine: 'var(--c-accent-line)',
  focusRing: 'var(--c-focus-ring)',

  ok: 'var(--c-ok)',
  okSoft: 'var(--c-ok-soft)',
  warn: 'var(--c-warn)',
  warnSoft: 'var(--c-warn-soft)',
  orange: 'var(--c-orange)',
  orangeSoft: 'var(--c-orange-soft)',
  danger: 'var(--c-danger)',
  dangerSoft: 'var(--c-danger-soft)',
  info: 'var(--c-info)',
  infoSoft: 'var(--c-info-soft)',
  violet: 'var(--c-violet)',
  violetSoft: 'var(--c-violet-soft)',
  infoBanner: 'var(--c-info-banner)',
  infoBannerLine: 'var(--c-info-banner-line)',

  overlay: 'var(--c-overlay)',
  shadow: 'var(--c-shadow)',
} as const;

export type ThemeToken = keyof typeof T;

/**
 * Тот же цвет с прозрачностью — для hex и для `var(--…)` одинаково
 * (`color-mix`), поэтому подсветка следует теме. `alpha` — 0..1 или
 * двузначная hex-альфа, как в прежней склейке `${color}1a`.
 */
export const withAlpha = (color: string, alpha: number | string): string => {
  const a =
    typeof alpha === 'string' ? parseInt(alpha, 16) / 255 : Number(alpha);
  // Простой hex — прежняя склейка `#rrggbbaa`: светлая тема и цвета из данных
  // (медали, навыки) не зависят от поддержки color-mix в браузере.
  if (/^#[0-9a-f]{6}$/i.test(color)) {
    const byte = Math.round(Math.min(Math.max(a, 0), 1) * 255);
    return `${color}${byte.toString(16).padStart(2, '0')}`;
  }
  const pct = Math.round(Math.min(Math.max(a, 0), 1) * 1000) / 10;
  return `color-mix(in srgb, ${color} ${pct}%, transparent)`;
};
